module.exports = __webpack_public_path__ + "static/media/06.740415a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/japan-five/06.jpg
// module id = 430
// module chunks = 0